export default __webpack_public_path__ + "static/media/datahublogo.80dcf761.png";